const css = `.survey-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  align-items: start;
  gap: 32px;
}
.survey-editor .survey-editor-main {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
.survey-editor .survey-editor-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--accent-subtle);
  border: 1px solid var(--accent-subtle);
  color: var(--text);
  font-size: var(--font-size-sm);
}
.survey-editor .survey-editor-note .pi {
  margin-top: 2px;
  color: var(--accent);
}
.survey-editor .survey-question-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 16px;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  transition: border-color 0.15s;
}
.survey-editor .survey-question-card:focus-within {
  border-color: var(--ring);
}
.survey-editor .survey-question-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.survey-editor .survey-question-card-badge {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background-color: var(--accent-chip);
  border: 1px solid var(--accent-chip-border);
  color: var(--accent-hover);
  font-weight: var(--font-weight-bold);
}
.survey-editor .survey-question-card-title {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.survey-editor .survey-question-card-title h3 {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
}
.survey-editor .survey-question-card-title span {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.survey-editor .survey-question-card-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.survey-editor .survey-question-card-field {
  display: flex;
  align-items: center;
  gap: 8px;
}
.survey-editor .survey-question-card-field .survey-question-card-translate.p-button,
.survey-editor .survey-question-card-field .survey-question-card-translate-spacer {
  flex: 0 0 auto;
  width: 2.5rem;
  height: 2.5rem;
}
.survey-editor .survey-question-card-field .p-inputtext {
  flex: 1;
  min-width: 0;
}
.survey-editor .survey-question-card-locale {
  flex-shrink: 0;
  width: 32px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--text-muted);
  letter-spacing: var(--letter-spacing-wide);
}
.survey-editor .survey-question-card-footer {
  display: flex;
  justify-content: flex-end;
}
.survey-editor .survey-editor-add {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 24px;
  border: 1.5px dashed var(--border-strong);
  border-radius: 16px;
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
}
.survey-editor .survey-editor-add small {
  margin-left: auto;
  font-weight: var(--font-weight-regular);
  color: var(--text-subtle);
}
.survey-editor .survey-editor-add:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-subtle);
}
.survey-editor .survey-editor-add:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  box-shadow: none;
}
.survey-editor .survey-editor-savebar {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 14px;
  background: var(--text);
  color: var(--surface-raised);
  box-shadow: var(--shadow-5);
}
.survey-editor .survey-editor-savebar ul {
  margin: 4px 0 0;
  padding-left: 16px;
  font-size: var(--font-size-sm);
  color: var(--surface-raised);
  opacity: 0.8;
}
.survey-editor .survey-editor-savebar .survey-editor-savebar-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.survey-editor .survey-editor-savebar .survey-editor-savebar-actions .p-button-text {
  color: var(--surface-raised);
}
.survey-editor .survey-preview {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.survey-editor .survey-preview-caption {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-wide);
  text-transform: uppercase;
  color: var(--text-subtle);
}
.survey-editor .survey-preview-phone {
  width: 300px;
  height: 600px;
  padding: 12px;
  border-radius: 40px;
  background: var(--text);
  box-shadow: var(--shadow-5);
}
.survey-editor .survey-preview-sheet {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 32px 16px 16px;
  border-radius: 30px;
  background: var(--surface);
  overflow: hidden;
  font-size: var(--font-size-xs);
}
.survey-editor .survey-preview-title {
  font-size: var(--font-size-base);
}
.survey-editor .survey-preview-intro,
.survey-editor .survey-preview-empty {
  margin: -8px 0 0;
  color: var(--text-muted);
}
.survey-editor .survey-preview-question {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: var(--font-weight-semibold);
  overflow-wrap: anywhere;
}
.survey-editor .survey-preview-question em {
  color: var(--danger);
  font-style: normal;
}
.survey-editor .survey-preview-textarea {
  height: 44px;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface-raised);
  color: var(--text-subtle);
  font-weight: var(--font-weight-regular);
}
.survey-editor .survey-preview-scale {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 4px;
}
.survey-editor .survey-preview-scale span {
  padding: 8px 0;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface-raised);
  text-align: center;
  font-weight: var(--font-weight-semibold);
}
.survey-editor .survey-preview-submit {
  margin-top: auto;
  padding: 12px;
  border-radius: 10px;
  background: var(--text);
  color: var(--surface-raised);
  text-align: center;
  font-weight: var(--font-weight-bold);
}
@media (max-width: 1100px) {
  .survey-editor {
    grid-template-columns: minmax(0, 1fr);
  }
  .survey-editor .survey-preview {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
